<div>
    <div class="container-fluid fixed-top ">
        <app-header></app-header>
    </div>
    <div class="container-fluid contact py-5">
        <div class="container py-5">
            <div class="row">
                <div class="col-2 py-5">
                    <div class="list-group position">
                        <button type="button" (click)="setOption(1)" [ngClass]="{'active': index==1}" class="list-group-item list-group-item-action">
                            Ordenes Pendientes
                        </button>
                        <button type="button" (click)="setOption(2)" [ngClass]="{'active': index==2}" class="list-group-item list-group-item-action">
                            Ordenes Pagadas
                        </button>
                        <button type="button" (click)="setOption(3)" [ngClass]="{'active': index==3}" class="list-group-item list-group-item-action">
                            Ordenes con Envío
                        </button>
                        <button type="button" (click)="setOption(4)" [ngClass]="{'active': index==4}" class="list-group-item list-group-item-action">
                            Ordenes Entregadas
                        </button>
                        <button type="button" (click)="setOption(5)" [ngClass]="{'active': index==5}" class="list-group-item list-group-item-action">
                            Todas las Ordenes
                        </button>
                    </div>
                </div>
                <div class="col-9 py-5">
                    <app-order-detail-update [showOrders]="index"></app-order-detail-update>
                </div>
            </div>
        </div>
    </div>
    <div>
        <app-footer></app-footer>
    </div>
</div>

